module.exports = __webpack_public_path__ + "img/03.b4428749.webp";